<template>
  <div>
    <md-card-header>
      <div class="md-title">Ações</div>
    </md-card-header>
    <form @submit.prevent="submitAcaoForm">
      <md-field :class="getValidationAcao('nomeExibicao')">
        <label for="nomeExibicao">Nome de Exibição</label>
        <md-input id="nomeExibicao" v-model="newAcao.nomeExibicao" />
        <span v-if="!$v.newAcao.nomeExibicao.required" class="md-error"
          >Um nome de exibição é requerido</span
        >
      </md-field>

      <md-field :class="getValidationAcao('acao')">
        <label for="acao">Comando que será enviado</label>
        <md-input id="acao" v-model="newAcao.acao" />
        <span v-if="!$v.newAcao.acao.required" class="md-error"
          >Uma ação é requerida</span
        >
      </md-field>
      <md-switch v-model="newAcao.apenasAdminExecuta">
        Restrito ao Administrador
      </md-switch>
      <br />
      <br />
      <material-picker v-model="newAcao.color" />
      <br />
      <br />
      <md-divider />
      <md-card-header style="padding-bottom: 0">
        <div class="row">
          <div class="col-6">
            <p class="md-subheading mb-0">Parametrização</p>
            <p class="md-caption">Adicione $VALOR ao comando</p>
          </div>
          <div class="col-6">
            <p>Calculado pela regra de 3</p>
            <p style="text-align: justify">
              {{ newAcao.xMAX || 'xMAX' }}
              <md-icon>arrow_right_alt</md-icon>
              {{ newAcao.yMAX === 0 ? 'yMAX' : newAcao.yMAX }}
              <br />
              Valor usuário
              <md-icon>arrow_right_alt</md-icon>
              Valor enviado
            </p>
          </div>
        </div>
      </md-card-header>
      <md-field :class="getValidationAcao('xMAX')">
        <label for="xMAX">xMAX (Valor máximo do usuário)</label>
        <md-input id="xMAX" v-model="newAcao.xMAX" type="number" />
      </md-field>
      <md-field :class="getValidationAcao('yMAX')">
        <label for="yMAX">yMAX</label>
        <md-select id="movie" v-model="newAcao.yMAX" name="movie">
          <md-option :value="0"> Nulo </md-option>
          <md-option :value="8192"> CFW 500/700 </md-option>
          <md-option :value="20000"> ABB </md-option>
        </md-select>
      </md-field>
      <md-divider />
      <md-card-header style="padding-bottom: 0">
        <p class="md-subheading mb-0">Mobile</p>
      </md-card-header>

      <md-field :class="getValidationAcao('smsConteudo')">
        <label for="smsConteudo">Conteudo SMS</label>
        <md-input id="smsConteudo" v-model="newAcao.smsConteudo" />
        <span v-if="!$v.newAcao.smsConteudo.required" class="md-error"
          >Uma ação é requerida</span
        >
      </md-field>

      <md-field :class="getValidationAcao('dialogoConteudo')">
        <label for="dialogoConteudo">Diálogo conteudo</label>
        <md-input id="dialogoConteudo" v-model="newAcao.dialogoConteudo" />
        <span v-if="!$v.newAcao.dialogoConteudo.required" class="md-error"
          >Um Diálogo é requerido</span
        >
      </md-field>

      <md-switch v-model="newAcao.dialogoContinuar">
        Dialogo de continuar
      </md-switch>

      <md-switch v-model="newAcao.esperaRetorno"> Espera retorno </md-switch>

      <md-card-actions>
        <md-button
          v-if="editanto"
          type="submit"
          class="md-accent"
          :disabled="sending"
          @click="cancelEdit"
        >
          Cancelar Edição
        </md-button>
        <md-button
          type="submit"
          class="md-primary"
          :disabled="sending"
          @click="() => (editanto ? editColor(editandoAcaoIndex) : addColor())"
        >
          {{ editanto ? 'Editar' : 'Adicionar' }}
        </md-button>
      </md-card-actions>
    </form>

    <md-divider />

    <md-list class="md-double-line">
      <md-subheader>Cadastrados</md-subheader>

      <md-list-item v-for="(data, index) in acoes" :key="data.acao">
        <md-icon
          class="md-primary"
          :style="{
            ['background-color']: data.color,
            ['border-radius']: '2px',
            ['min-height']: '2vh',
            ['min-width']: '2vh',
          }"
        />
        <div class="md-list-item-text">
          <span>{{ data.nomeExibicao || data.acao }}</span>
        </div>

        <button
          class="md-button md-list-action md-rounded"
          @click="() => setEditColor(index)"
        >
          <md-icon class="md-primary"> edit </md-icon>
        </button>

        <button
          class="md-button md-list-action"
          @click="() => removeColor(data)"
        >
          <md-icon class="md-accent"> backspace </md-icon>
        </button>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
import { Compact } from 'vue-color'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../../utils/http'

export default {
  name: 'EquipamentoGerenciarAcoes',
  components: {
    'material-picker': Compact,
  },
  mixins: [validationMixin],
  props: {
    equipamentoId: String,
    sending: Boolean,
  },
  data() {
    return {
      editanto: false,
      newAcao: {
        color: '#ffffff',
        acao: null,
        nomeExibicao: null,
        smsConteudo: null,
        dialogoConteudo: null,
        dialogoContinuar: false,
        esperaRetorno: false,
        apenasAdminExecuta: false,
        xMAX: null,
        yMAX: 0,
      },
      acoes: [],
    }
  },
  async mounted() {
    if (this.equipamentoId) {
      await this.loadData(this.equipamentoId)
    }
  },
  methods: {
    async loadData(equipamentoId) {
      this.acoes = (
        await http.get(`equipamento/${equipamentoId}/botao`)
      ).botoes.map((e) => {
        return {
          ...e,
          color: e.cor || e.color,
        }
      })

      this.$emit('change', this.acoes)
    },
    getValidationAcao(fieldName) {
      const field = this.$v.newAcao[fieldName]

      if (field) {
        return {
          'md-invalid': field.$error,
        }
      }
    },
    addColor() {
      this.$v.newAcao.$touch()

      if (this.$v.newAcao.$invalid) {
        return
      }

      this.acoes.push({
        ...this.newAcao,
        color: this.newAcao.color.hex || '#ffffff',
      })

      this.limparFormularioAcao()

      setTimeout(() => {
        this.$v.$reset()
      }, 0)

      this.$emit('change', this.acoes)
    },
    limparFormularioAcao() {
      this.newAcao = {
        color: '#ffffff',
        acao: null,
        nomeExibicao: null,
        smsConteudo: null,
        dialogoConteudo: null,
        dialogoContinuar: false,
        apenasAdminExecuta: false,
        xMAX: null,
        yMAX: null,
      }
    },
    removeColor(obj) {
      this.acoes = this.acoes.filter((e) => e !== obj)
      this.$emit('change', this.acoes)
    },
    editColor() {
      this.$v.newAcao.$touch()

      if (this.$v.newAcao.$invalid) {
        return
      }

      this.acoes.splice(this.editandoAcaoIndex, 1, {
        ...this.newAcao,
        yMAX: this.newAcao.yMAX === 0 ? null : this.newAcao.yMAX,
        color: this.newAcao.color.hex || this.newAcao.color,
      })

      this.limparFormularioAcao()

      this.editanto = false

      setTimeout(() => {
        this.$v.$reset()
      }, 0)
      this.$emit('change', this.acoes)
    },
    setEditColor(index) {
      this.editanto = true

      this.newAcao = { ...this.acoes[index], yMAX: this.acoes[index].yMAX || 0 }

      this.editandoAcaoIndex = index
    },
    cancelEdit() {
      this.editanto = false

      this.limparFormularioAcao()
    },
    submitAcaoForm() {
      if (this.editanto) {
        this.editColor()
      } else {
        this.addColor()
      }
    },
  },
  validations: {
    newAcao: {
      acao: {
        required,
      },
      nomeExibicao: {
        required,
      },
      smsConteudo: {
        required,
      },
      dialogoConteudo: {
        required,
      },
    },
  },
}
</script>
